import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import cus3 from '../images/cus3.jpg'
import cus1 from '../images/cus1.jpg'
import cus2 from '../images/cus2.jpg'
import { useTranslation } from 'react-i18next';

const customersData = [
    {
        id: 1,
        rating: 4,
        image: cus3,
        name: "Sébastien",
        location: "https://goo.gl/maps/47x97ggHVTWFTuku9"
    },
    {
        id: 2,
        rating: 5,
        image: cus1,
        name: "Julien",
        location: "https://goo.gl/maps/Ve2fQmNfJYUiuY2z8"
    },
    {
        id: 3,
        rating: 5,
        image: cus2,
        name: "Sarah",
        location: "https://goo.gl/maps/Ve2fQmNfJYUiuY2z8"
    }
];

const Review = () => {
    const { t } = useTranslation();
    
    return (
        <section className="customers" id="customers">
            <div className="sec-width">
                <div className="title">
                    <h2>{t('reviews.title')}</h2>
                </div>
                <div className="customers-container">
                    {customersData.map((customer, index) => (
                        <div className="customer" key={customer.id}>
                            <a href={customer.location}>
                                <div className="rating">
                                    {Array(customer.rating).fill().map((_, starIndex) => (
                                        <span key={starIndex}><FontAwesomeIcon icon={faStar} /></span>
                                    ))}
                                    {Array(5 - customer.rating).fill().map((_, starIndex) => (
                                        <span key={starIndex}><FontAwesomeIcon icon={faStar} /></span>
                                    ))}
                                </div>
                                <h3>{t(`reviews.customers.${index}.title`)}</h3>
                                <p>{t(`reviews.customers.${index}.review`)}</p>
                                <img src={customer.image} alt="customer" />
                                <span>{customer.name}</span>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Review;
